<template>
  <!-- O resumo linearizado em até duas linhas, e o ⤢ que abre o texto desenhado por cima, quando o
       resumo não mostra tudo (escolha do usuário). O visualizador só nasce ao abrir — o conteúdo do
       v-menu é preguiçoso —, e não um por resumo. -->
  <div class="md-expandable">
    <ontos-markdown-excerpt :value="value" :full="full" class="md-expandable-text"
                            :class="{'md-expandable-text--clamped': clamped}"/>
    <v-menu v-if="!showsAll" location="bottom end" :close-on-content-click="false">
      <template #activator="{props: menuProps}">
        <!-- `.stop`: numa linha de tabela, o clique abre o item -->
        <v-btn v-bind="menuProps" icon="mdi-arrow-expand" size="x-small" variant="text" density="comfortable"
               class="no-drag" :title="$tt('expand')" :aria-label="$tt('expand')" @click.stop/>
      </template>
      <v-card class="md-expandable-popover">
        <markdown-viewer :initialValue="value"/>
      </v-card>
    </v-menu>
  </div>
</template>

<script lang="ts">
import {Component, Vue, Prop, toNative} from 'vue-facing-decorator'
import MarkdownExcerpt from './MarkdownExcerpt.vue'
import MarkdownViewer from './MarkdownViewer.vue'
import {excerptShowsAll, isSingleLineMarkdown} from '@/utils/markdownExcerpt'

/**
 * Markdown resumido, com o ⤢ para ler inteiro. Era só da célula da grade e dos campos da ficha, dentro
 * do PropertyValue; a descrição na página de entrada do ambiente pediu o mesmo (escolha do usuário,
 * contra um "ver mais" no lugar), e o gesto virou um componente — o mesmo em todo o app.
 *
 * `full`: o resumo sem o teto de caracteres, cortado só pela largura, nas duas linhas — o de uma linha
 * inteiro, sem corte e sem o ⤢. Sem ele, o resumo de 120 caracteres da grade.
 */
@Component({
  name: 'ontos-markdown-expandable',
  components: {'ontos-markdown-excerpt': MarkdownExcerpt, 'markdown-viewer': MarkdownViewer}
})
class MarkdownExpandable extends Vue {
  @Prop({default: ''}) readonly value!: unknown
  @Prop({type: Boolean, default: false}) readonly full!: boolean

  /** O resumo já mostra tudo? Então não há o que expandir. */
  get showsAll(): boolean {
    return this.full ? isSingleLineMarkdown(this.value) : excerptShowsAll(this.value)
  }

  /** Em duas linhas: sempre na grade, que tem a altura da linha orçada; o inteiro, só quando há mais. */
  get clamped(): boolean {
    return !this.full || !this.showsAll
  }
}

export default toNative(MarkdownExpandable)
</script>

<style scoped>
/* O resumo e o ⤢ lado a lado */
.md-expandable {
  display: flex;
  align-items: flex-start;
  gap: 2px;
}

/* Até duas linhas, com reticências */
.md-expandable-text--clamped {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  overflow: hidden;
}

/* O texto desenhado, por cima da tela, com rolagem quando é longo */
.md-expandable-popover {
  max-width: min(520px, 90vw);
  max-height: 60vh;
  overflow: auto;
  padding: 12px 16px;
}
</style>
